import React from 'react'
import {Route, Routes} from "react-router-dom";
import ContactTemplate from "./components/contact/contact-template";
import About from "./components/About/about";
import HomePage from "./components/home/homepage";
import ServicesWebDesign from "./components/services/webdesign/service-webdesign";
import ServicesCustomWebDev from "./components/services/webdevelopment/service-custom-webdev";
import PrivacyPolicy from "./components/contact/privacy-policy";



const Routess = () => {


    return (
        <div>
            <Routes>
                <Route path="/" element={<HomePage/>} />
                <Route path="/contact" element={<ContactTemplate/>} />
                <Route path="/about" element={<About/>} />
                <Route path="/privacy" element={<PrivacyPolicy/>} />
                <Route path="/services/web-design" element={<ServicesWebDesign/>} />
                <Route path="/services/web-applications" element={<ServicesCustomWebDev/>} />

            </Routes>
        </div>






    )











}

export default Routess;